import React from 'react';
import ClientCarousel from '../home/client-carousel';
import Link from 'next/link';

const AboutUsHero = () => {
    return (
        <section className="hero technology-herosection ">
            <div className="container lg:container md:mx-auto top-hero">
                <div className="lg:grid hero-row gap-6 relative z-[1] h-full">
                    <div className="w-full">
                        <div className="inline-flex flex-col lg:items-start gap-4 hero-content justify-center h-full">
                            <h1 className="mb-0 text-primary sm:text-3xl md:text-5xl md:leading-[60px] sm:w-full md:w-auto">
                                Engineering Intelligence. Empowering Businesses.
                            </h1>
                            <p className="mb-0 font-semibold text-secondary dark:text-secondary">
                                For over 18 years, Moweb Technologies has been a trusted technology partner for enterprises,
                                fast-growing SMEs, and innovators across India, USA, UK, and Tanzania.
                            </p>
                            <p className="mb-0 font-semibold text-secondary dark:text-secondary">
                                We specialize in AI enablement, enterprise digital transformation, and product engineering,
                                helping organizations modernize, scale, and build technology that drives measurable business
                                outcomes.
                            </p>
                            <Link href="/contact-us" className="btn btn-primary">
                                Talk to Our FinTech Experts
                            </Link>
                        </div>
                    </div>
                    <div className="text-center lg:text-end lg:self-center">
                        <div className="md:block">
                            <img
                                src="/img/img-about-us-hero@2x.png"
                                alt="about-us-image"
                                width={630}
                                height={451}
                                className="max-w-[100%]"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default AboutUsHero;
